import { render, staticRenderFns } from "./Login-qa.vue?vue&type=template&id=72fbfe70&"
import script from "./Login-qa.vue?vue&type=script&lang=js&"
export * from "./Login-qa.vue?vue&type=script&lang=js&"
import style0 from "./Login-qa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports